import React, { useEffect, useState } from 'react';
import './styles/Dashboard.css';
import { FaBoxOpen, FaChevronRight, FaComments, FaImages, FaMailBulk, FaReceipt, FaUsers, FaMapMarkedAlt, FaHistory, FaNewspaper, FaBookOpen } from 'react-icons/fa';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Login from './modules/Login';
import { useCookies } from 'react-cookie';
import axiosPost from '../../helper/axios-helper';


export default function Dashboard() {
    const [menu, setMenu] = useState([
        {
            name: 'Home',
            type: 'header'
        },
        {
            id: 2,
            name: "Banners",
            type: 'option',
            ref: 'home_banners',
            icon: <FaImages />
        },
        {
            id: 3,
            name: "Testimonials",
            type: 'option',
            ref: 'testimonials',
            icon: <FaComments />
        },
        {
            name: "Membership",
            type: 'header',
        },
        {
            id: 10,
            name: "Members",
            type: 'option',
            ref: 'members',
            icon: <FaMapMarkedAlt />
        },
        {
            name: "Events",
            type: 'header',
        },
        {
            id: 4,
            name: "Canto Connect",
            type: 'option',
            ref: 'canto_connect',
            icon: <FaUsers />
        },
        {
            id: 5,
            name: "Canto Conference",
            type: 'option',
            ref: 'canto_conference',
            icon: <FaUsers />
        },
        {
            id: 6,
            name: "Canto Conversations",
            type: 'option',
            ref: 'canto_conversations',
            icon: <FaUsers />
        },
        {
            id: 13,
            name: "AGM Documents",
            type: 'option',
            ref: 'agm_documents',
            icon: <FaReceipt />
        },
        {
            name: "Publications",
            type: 'header',
        },
        {
            
            id: 11,
            name: "Press Releases",
            type: 'option',
            ref: 'press_releases',
            icon: <FaNewspaper />
        },
        {
            id: 12,
            name: "CANCION Current Issue",
            type: 'option',
            ref: 'cancion_current_issue',
            icon: <FaBookOpen />
        },
        {
            name: "Contact",
            type: 'header',
        },
        {
            id: 8,
            name: "Contact Forms",
            type: 'option',
            ref: 'contact_forms',
            icon: <FaMailBulk />
        },
        {
            id: 9,
            name: "FAQs",
            type: 'option',
            ref: 'faqs',
            icon: <FaMailBulk />
        },
        {
            name: "About",
            type: 'header',
        },
        {
            id: 10,
            name: "CANTO History",
            type: 'option',
            ref: 'history',
            icon: <FaHistory />
        },
    ])

    const [ account, setAccount ] = useState(null);
    const [cookies, setCookie, removeCookie] = useCookies(["account-canto"]);
    const [ selectedOption, setSelectedOption ] = useState(1);
    const [ fetching, setFetching ] = useState(false);

    useEffect(() => {
        refreshAccount();
    }, [])

    const refreshAccount = () => {
        if (!fetching) {
        axiosPost(
            "account/refresh",
            {auth: cookies["account-canto"]},
            {},
            (data) => {
            const { success, response } = data;

                if (success) {
                    
                    const accountRaw = data.data;

                    setAccount((oldAccount) => {
                        return {
                            ...oldAccount,
                            ...accountRaw,
                        };
                    });

                    console.log("Account: ", account)
                } else {
                    
                }
            }
        );
        }
    };

    const Sidebar = () => {

        console.log(account)

        const render_options = menu.map((item, index) => {
            if(item.type == 'header'){
                return (
                    <div className='SidebarHeader'>{item.name}</div>
                )
            }

            return (
                <Link to={item.ref} className={`SidebarOption ${(selectedOption == item.id) ? 'Active' : ''}`} onClick={() => {
                    setSelectedOption(item.id)
                }}>
                    <div className='SidebarOptionIcon'>
                        {item.icon}
                    </div>
                    <div className={`SidebarOptionText ${(selectedOption == item.id) ? 'Active' : ''}`}>{item.name}</div>
                    <FaChevronRight size={12} color={(selectedOption == item.id) ? '#87BEC0' : '#fff'} />
                </Link>
            )
        })

        return (
            <div className='Sidebar'>
                <div className='DashboardLogoWrapper'>
                    <img src={process.env.PUBLIC_URL + '/assets/nav_logo.png'} className='DashboardLogo' style={{height: '50px'}}/>
                </div>
                <div className='SidebarAccount'>
                    <div className='SidebarAccountAvatar'></div>
                    <div className='SidebarAccountInfo'>
                        <div className='SidebarAccountInfoTitle'>{account.first_name + ' ' + account.last_name}</div>
                        <div className='SidebarAccountInfoSub'>{account.role}</div>
                    </div>
                </div>

                <div className='SidebarHeader' style={{color: '#fff'}}>Options</div>
                <div className='SidebarOptions'>
                    {render_options}
                </div>
            </div>
        )

    }

    return (
        <div className='Dashboard'>
            { (account) ? 

                <>
                    <Sidebar />

                    <div className='DashboardContent'>
                        <Outlet context={{ account }} />
                    </div>
                </>

                :

                <Login
                    setAccount={setAccount}
                />

            }
            
        </div>
    )
}
